import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 人员进出记录
  mobileaccessRecordpage(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/accessRecord/page',
      method: 'get',
      params: args
    })
  },

  // 人员二维码详情
  getQrDeatail(id, type) {
    return Axios({
        url: requestPrefix.projectUrl + `/projectQrCode/getRecent/${id}/${type}`,
        method: 'get',
    })
  },
  // 人员录入提交
  getQrmobileSave(data) {
    return Axios({
        url: requestPrefix.projectUrl + '/person/mobileSave',
        method: 'post',
        data
    })
  },

  // 查询安装人
  searchInstall(params) {
    return Axios({
        url: requestPrefix.deviceServerUrl + '/install/getPerson',
        method: 'get',
        params
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/personmanagement/index.js